import { Box, Grid } from "@mui/material";
import { validate } from "../../helper/losDataHelper";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { CollateralAddressInfoColumns } from "../ApplicationInfoHelper";

const CollateralAddressInformation = ({ collateralAddressInformationData }) => {
  return (
    <>
      <AccordianContainer
        id="accord"
        title="Collateral Address Information"
        initialOpen={false}
      >
        <Box sx={{ marginTop: "-1%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={
              validate(collateralAddressInformationData)
                ? collateralAddressInformationData.map((item, index) => ({
                    id: index + 1,
                    ...item,
                  }))
                : []
            }
            columns={CollateralAddressInfoColumns}
            getRowId={(row) => row.collateralassessmentid}
            pageSize={20}
            pageSizeOptions={[20]}
            gridLazyLoad={() => {}}
            gridHeight={300}
            gridWidth={window.innerWidth - 40}
          />
        </Box>
      </AccordianContainer>
    </>
  );
};

export default CollateralAddressInformation;
